import { RoomEditorState } from 'arcade/sections/rooms/interfaces';
import { CabinetEntry, Room } from 'shared/interfaces';
import * as types from './types';
import { getArcadeId } from '../arcade/selectors';
import {
    apiDeleteArcadeRoom,
    apiGetArcadeRoom,
    apiGetArcadeRooms,
    apiPostArcadeRoom,
    apiPutArcadeRoom
} from './api';
import {
    getRoomCabinets,
    mapCabinetIds
} from './selectors';

export const setArcadeRooms = (rooms: Room[]) => ({ type: types.ARCADE_ROOM__SET_ROOMS, rooms });
export const getArcadeRooms = (arcadeId?: string)  => async (dispatch, getState) => {
    arcadeId = arcadeId || getArcadeId(getState());
    if (!arcadeId) {
        throw new Error('No arcade is being edited');
    }
    const results = await apiGetArcadeRooms(arcadeId);
    return await dispatch(setArcadeRooms(results.rooms));
};

export const setRoom = (room: RoomEditorState) => ({ type: types.ARCADE_ROOM__SET_ROOM, room });
export const getArcadeRoom = (roomId: string) => async (dispatch) => {
    const results = await apiGetArcadeRoom(roomId);
    return await dispatch(setRoom(results));
};

export const createArcadeRoom = (room: Room) => async (dispatch, getState) => {
    const state = getState();
    const arcadeId = getArcadeId(state);
    room = { ...room, cabinets: mapCabinetIds(state) };
    await apiPostArcadeRoom(arcadeId, room);
    return await dispatch(getArcadeRooms(arcadeId));
};
export const updateArcadeRoom = (room: Room, id: string) => async (dispatch, getState) => {
    const state = getState();
    const arcadeId = getArcadeId(state);
    room = { ...room, cabinets: mapCabinetIds(state) };
    await apiPutArcadeRoom(room, id);
    return await dispatch(getArcadeRooms(arcadeId));
};

export const deleteArcadeRoom = (id: string) => async (dispatch, getState) => {
    const arcadeId = getArcadeId(getState());
    await apiDeleteArcadeRoom(id);
    await dispatch(getArcadeRooms(arcadeId));
};

export const clearRoom = () => ({ type: types.ARCADE_ROOM__CLEAR_ROOM });

export const setRoomCabinets = (cabinets: CabinetEntry[]) => ({ type: types.ARCADE_ROOM__SET_ROOM, cabinets });
export const setReorderedCabinets = (cabinets: CabinetEntry[]) => ({ type: types.ARCADE_ROOM__SET_REORDERED_CABINETS, cabinets });
export const addCabinetToRoom = (cabinet: CabinetEntry) => ({ type: types.ARCADE_ROOM__ADD_CABINET_TO_ROOM, cabinet });
export const setRoomValue = (name: string, value: any) => ({ type: types.ARCADE_ROOM__SET_ROOM_VALUE, name, value });

export const removeRoomCabinet = (cabinetId: string) => async (dispatch, getState) => {
    const state = getState();
    let cabinets = getRoomCabinets(state);
    const index = cabinets.findIndex(cabinet => cabinet.cabinetId === cabinetId);
    cabinets.splice(index, 1);
    cabinets = cabinets.map((cabinet) => ({ ...cabinet }));
    dispatch(setReorderedCabinets(cabinets));
};
